<template>
  <div>
    <footer class="footer" :class="this.footer == 'footer-dark' ? 'footer-dark' : ''">
      <div class="container-fluid">
        <div class="row">
          <div class="col-md-12 footer-copyright text-center">
            <p class="mb-1">&nbsp; <a href="#" target="_blank">{{this.currentLanguage ==='en'?'Organizer':'ผู้จัดกิจกรรม'}}</a> &nbsp;<a
                href="/find-order">{{this.currentLanguage ==='en'?'Find order':'ค้นหาใบสมัคร'}}</a> &nbsp;<a href="/">{{this.currentLanguage ==='en'?'Registration system':'ระบบรับสมัครงานวิ่ง'}}</a>&nbsp; <a href="/"> Copyright
                2024 © RUNRACE.IN.TH</a></p>
            <p class="mb-1 footer-legal-links">
              <router-link to="/terms-of-use#terms">{{this.currentLanguage ==='en'?'Terms of Service':'ข้อตกลงการใช้บริการ'}}</router-link>&nbsp; · &nbsp;
              <router-link to="/terms-of-use#refund">{{this.currentLanguage ==='en'?'Refund Policy':'นโยบายการคืนเงิน'}}</router-link>&nbsp; · &nbsp;
              <router-link to="/terms-of-use#privacy">{{this.currentLanguage ==='en'?'Privacy Policy':'นโยบายความเป็นส่วนตัว'}}</router-link>&nbsp; · &nbsp; 
              <router-link to="/how-to-use-admin">{{this.currentLanguage ==='en'?'How to use the system':'วิธีการใช้งานระบบ'}}</router-link>
            </p>
            <b>{{ companyName }}</b>
          </div>
        </div>
      </div>
    </footer>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  name: 'footerpage',
  data() {
    return {
      customizer: false,
      currentLanguage: 'th',
      companyName: process.env.VUE_APP_COMPANY_NAME || 'RUNNING DIGITAL SOLUTION CO., LTD.'

    };
  },
  mounted(){
    if(localStorage.getItem('currentLanguage') !== null){
      this.currentLanguage = localStorage.getItem('currentLanguage');
    }
  },
  computed: {
    ...mapGetters({
      footer: 'layout/footer'
    })
  }
};
</script>
